// src/config/index.js
const DEV_API = "http://127.0.0.1:8001";
const DEV_WS  = "ws://127.0.0.1:8001";

export const API_BASE_URL = import.meta.env.DEV
  ? DEV_API
  : (import.meta.env.VITE_API_BASE_URL || DEV_API);

export const WS_BASE_URL = import.meta.env.DEV
  ? DEV_WS
  : (() => {
      const host = import.meta.env.VITE_WS_HOST || "localhost:8001";
      const proto = window.location.protocol === "https:" ? "wss" : "ws";
      return `${proto}://${host}`;
    })();

// Debug-Log (nur temporär)
console.log("[cfg] DEV:", import.meta.env.DEV,
            "API_BASE_URL:", API_BASE_URL,
            "WS_BASE_URL:", WS_BASE_URL);
